import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'raceCourse'
})
export class RaceCoursePipe implements PipeTransform {

  transform(value: unknown, itemIndex: any, sideCol) {
    const raceIndex = itemIndex;
    return (value === 'C') ? (value + ' ' + raceIndex) : sideCol ? (raceIndex + '.R.') : (raceIndex + '. ' + value);
  }

}
